const getWidthOrHeight = (width: number, height?: number) => {
  if (height !== undefined) {
    return { h: `${height}rem` }
  }
  return { w: `${width}rem` }
}

export default getWidthOrHeight
